// src/admin/components/StatusBadge.jsx
import React from 'react';

const PALETTE = {
  completed: { bg: 'rgba(16,185,129,0.08)', fg: '#10B981' },
  approved:  { bg: 'rgba(16,185,129,0.08)', fg: '#10B981' },
  failed:    { bg: 'rgba(239,68,68,0.08)',  fg: '#EF4444' },
  drafting:    { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  reviewing:   { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  correcting:  { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  refining:    { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  qa_checking: { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  reparse:     { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  sanitizing:  { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  li_format:   { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
  seo_html:    { bg: 'rgba(245,158,11,0.08)', fg: '#B45309' },
};

export default function StatusBadge({ status }) {
  const key = (status || '').toLowerCase();
  const c = PALETTE[key] || { bg: 'rgba(0,0,0,0.04)', fg: '#6b6b6e' };
  return (
    <span style={{
      padding: '2px 8px', borderRadius: '4px',
      fontSize: '11px', fontWeight: 600,
      background: c.bg, color: c.fg,
      fontFamily: "'DM Sans', sans-serif",
      textTransform: 'lowercase',
    }}>
      {status || '—'}
    </span>
  );
}
